// extracted by mini-css-extract-plugin
export default {"personName":"PersonList__personName___OxV9q","attended":"PersonList__attended___SXVi1"};